export { default as ResourceOverviewWidget } from "./resource_overview_widget";
export { default as WidgetEditResourceOverview } from "./resource_overview_widget_form";

import * as ResourceOverviewWidgetFactory from "./resource_overview_widget_factory";

export { ResourceOverviewWidgetFactory };
